const Utils = function(app) {
  const _ = require('lodash');

  const defaultObject = [
    'oms',
    'oms_sku',
    'oms_ct1',
    'oms_tc1',
    'oms_pl1',
    'oms_tx1',
    'oms_ct2',
    'oms_tc2',
    'oms_pl2',
    'oms_tx2',
    'oms_ct3',
    'oms_tc3',
    'oms_pl3',
    'oms_tx3',
    'oms_ct4',
    'oms_tc4',
    'oms_pl4',
    'oms_tx4'
  ];

  function getOmsHtml(recipe) {
    const _default = _.clone(defaultObject);
    const omsKeys = Object.keys(recipe.localized_configuration).filter(function(key) {
      const isOms = key.indexOf('oms') !== -1;

      if ( isOms ) {
        const index = _default.indexOf(key);

        if ( index >= 0 ) {
          _default.splice(index, 1);
        }
      }

      return isOms;
    });

    const keys = omsKeys.concat(_default);
    const omsObj = keys.reduce(function(obj, key) {
      obj[key] = recipe.localized_configuration[key] || '';
      return obj;
    }, {});
    let markup = '';
    markup += '<div style="padding: 20px 30px;">';

    if (!app.appUtils.isDTGProduct()) {
      markup += '<div style="padding:5px 0;"><strong>Item Details:</strong> <pre>'+ JSON.stringify(omsObj, null, 2) +'</div>';
    } else {
      markup += '<div style="padding:5px 0;"><strong>Item Details:</strong> <pre>'+ JSON.stringify(recipe.custom, null, 2) +'</div>';
      markup += '<div style="padding:5px 0;"><strong>On RAL env we would call add to cart with the following edited params <br /> that won\'t be at the recipe itself</strong> </div>';
      markup += '<div style="padding:5px 0;"><strong>Localized Configuration:</strong> <pre>'+ JSON.stringify(recipe.localized_configuration, null, 2) +'</div>';
      markup += '<div style="padding:5px 0;"><strong>Configuration:</strong> <pre>'+ JSON.stringify(recipe.configuration, null, 2) +'</div>';
    }
    markup += '</div>';
    return markup;
  }

  return {
    getOmsHtml
  };
};

module.exports = Utils;
